import { CmsComponent, Converter } from '@spartacus/core'
import { Injectable, InjectionToken } from '@angular/core'
import { ConvertedComponentData, TextInput } from '../../types'
import { CmsConverterService, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class CongressContainerIconAboveTextConverter extends CmsConverterService<CongressContainerIconAboveTextData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      icon: formData.st_icon?.value?.identifier ?? '',
      iconCaption: formData.st_icon_caption ?? defaultTextInput,
      text: formData.st_text ?? defaultTextInput
    }
  }
}

export const CONGRESS_CONTAINER_ICON_ABOVE_TEXT_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, CongressContainerIconAboveTextData>>('CongressContainerIconAboveTextConverter')

export interface CongressContainerIconAboveTextData extends ConvertedComponentData {
  icon: string;
  text: TextInput;
  iconCaption: TextInput;
}
